"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promotionReducer = promotionReducer;
var _types = require("./types");
var _types2 = require("../game/types");
var _types3 = require("../blitz/types");
var _PromotionType = require("../../common/enums/PromotionType");
var initialState = {};
function promotionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types3.BLITZ_ROUND_RESULT:
    case _types2.ROUND_START:
      {
        var newState = Object.assign({}, state);
        if (newState.on) {
          newState.roundsPlayed = newState.roundsPlayed + 1;
          switch (state.type) {
            case _PromotionType.PromotionType.FreeGames:
            case _PromotionType.PromotionType.FeatureTrigger:
              newState.roundsLeft = newState.roundsLeft - 1;
              break;
            default:
              break;
          }
        }
        return newState;
      }
    case _types.PROMOTION_START:
      {
        return Object.assign({}, state, {
          on: true,
          offerId: action.payload.promotionOfferId,
          rounds: action.payload.rounds,
          roundsLeft: action.payload.rounds ? action.payload.rounds - action.payload.roundsPlayed : 0,
          roundsPlayed: action.payload.roundsPlayed ? action.payload.roundsPlayed : 0,
          type: action.payload.promotionType,
          duration: action.payload.duration,
          durationPlayed: action.payload.durationPlayed,
          durationLeft: action.payload.duration - action.payload.durationPlayed,
          lockedFeatureSet: action.payload.lockedFeatureSet,
          featureType: action.payload.featureType,
          featureTriggerId: action.payload.featureTriggerId
        });
      }
    case _types.PROMOTION_END:
      {
        return Object.assign({}, state, {
          on: false,
          offerId: null,
          roundsPlayed: action.payload.roundsPlayed,
          totalWin: action.payload.totalWin,
          roundsLeft: null,
          lockedFeatureSet: null
        });
      }
    case _types.PROMOTION_CANCEL:
      {
        return Object.assign({}, state, {
          on: false
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map